// =============================================================
// prefers-reduced-motion — reactive subscription (mimari plan)
// =============================================================

import { useEffect, useState, useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(callback: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  const mql = window.matchMedia(QUERY);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

function getSnapshot(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia(QUERY).matches;
}

function getServerSnapshot(): boolean {
  return false;
}

/** React 19 useSyncExternalStore — reactive, server-safe */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/** Imperative read (e.g., inside useGSAP callback) */
export function reducedMotionNow(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia(QUERY).matches;
}